module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/7mill-inactive-b6da3d272d81ba4e16491bf6ae6323de.png";